const Lights = ({bgColor, enableControls}) =>
{
    let intensity = 4

    return(
        <>
            {/* <Environment preset="sunset" /> */}
            <directionalLight position={[0,1,1]} intensity={intensity} color='#8888ff' shadow-mapSize={[1024, 1024]} />
            <directionalLight position={[0,1,-1]} intensity={intensity} color='#8888ff' shadow-mapSize={[1024, 1024]} />
            <hemisphereLight intensity={1} />
            {/* <spotLight position={[5, 5, 2]} intensity={2} color={'#fafafa'} angle={0.6} penumbra={0.5} castShadow />
            <spotLight position={[-5, 5, 2]} intensity={3} color={[0.15, 0.5, 1]} angle={0.6} penumbra={0.5} /> */}
        </>
    )
}

export default Lights